import { LossExpressSearchRequest } from '@upstart/harmony/lib/legos/lossExpressTypes';
import BackendService from './BackendService';

export default class LossExpressService {
  static getLenders(search: string) {
    const params = {
      name: search,
    };
    return BackendService.get(`/lossexpress/lenders`, { params });
  }

  static lookupPayoff(dealId: string, payoffSearch: LossExpressSearchRequest) {
    return BackendService.post(`/lossexpress/${dealId}/payoff`, {
      body: payoffSearch,
    });
  }
}
